import { render, staticRenderFns } from "./ArrivalFollowList.vue?vue&type=template&id=933bc372&scoped=true&"
import script from "./ArrivalFollowList.vue?vue&type=script&lang=js&"
export * from "./ArrivalFollowList.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalFollowList.vue?vue&type=style&index=0&id=933bc372&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933bc372",
  null
  
)

export default component.exports